import axios from 'axios';
import { Dispatch } from 'redux';
import TRANSACTION_TYPES from './types';
import { ENV_CONFIG } from 'config/environment';
import { showToast } from 'components/Toast';
import API_ROUTES from 'services/apiRoutes';
import { getAccessToken } from 'services/storage';
import type { RootState } from 'store/create-store';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'X-Auth-Version': 'v2',
};

export const getTransactionTotal =
  (key: string, start_date: string, end_date: string, client_id: number | null) =>
  async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
    dispatch(TRANSACTION_TYPES.transactionStart());
    const clientID = client_id ? `&client_id=${client_id}` : '';
    const activeRole = getState().admins?.activeRole ?? '';
    const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.GET_TRANSACTION_TOTAL(start_date, end_date, clientID)}&active_role=${activeRole}`;

    try {
      const response = await axios.get(url, {
        headers: { ...headers, Authorization: `Bearer ${getAccessToken()}` },
      });
      if (key === 'today') dispatch(TRANSACTION_TYPES.transactionTotalTodaySuccess(response.data));
      if (key === 'yesterday')
        dispatch(TRANSACTION_TYPES.transactionTotalYesterdaySuccess(response.data));
    } catch (error: any) {
      showToast(error.message, 'error', error?.response?.status);
      dispatch(TRANSACTION_TYPES.transactionTotalError(error.message));
    }
  };
